// Etiquetas en español de los estados de la fase 4. Cada una devuelve
// { status, label } para <StatusBadge status={…}>{label}</StatusBadge>.

// Estado del promotor (aprobación del admin).
export const PROMOTER_STATUS = {
  pending: { status: 'pending', label: 'Pendiente de aprobación' },
  approved: { status: 'approved', label: 'Aprobado' },
  rejected: { status: 'rejected', label: 'Rechazado' },
  suspended: { status: 'suspended', label: 'Suspendido' },
};

export const promoterStatus = (value) =>
  PROMOTER_STATUS[value] || { status: value, label: value || 'Desconocido' };

// Relación promotor ↔ empresa (solicitud).
export const LINK_STATUS = {
  pending: { status: 'pending', label: 'Pendiente' },
  accepted: { status: 'accepted', label: 'Aceptada' },
  rejected: { status: 'rejected', label: 'Rechazada' },
  revoked: { status: 'revoked', label: 'Revocada' },
};

export const linkStatus = (value) =>
  LINK_STATUS[value] || { status: value, label: value || 'Desconocido' };

// Quién terminó una relación (`endedBy`).
export const endedByLabel = (value) => {
  if (value === 'empresa') return 'la empresa';
  if (value === 'promoter') return 'el promotor';
  return '';
};

// Venta atribuida: pending | valid | cancelled.
export const SALE_STATUS = {
  pending: { status: 'pending', label: 'Pendiente' },
  valid: { status: 'valid', label: 'Vigente' },
  cancelled: { status: 'cancelled', label: 'Cancelada' },
};

export const promoterSaleStatus = (value) =>
  SALE_STATUS[value] || { status: value, label: value || 'Desconocido' };

export const SALE_SOURCE = { online: 'En línea', in_person: 'En persona' };

export const saleSourceLabel = (value) => SALE_SOURCE[value] || value || '—';

// Corte semanal: open | paid.
export const CUT_STATUS = {
  open: { status: 'open', label: 'Por pagar' },
  paid: { status: 'paid', label: 'Pagado' },
};

export const cutStatus = (value) =>
  CUT_STATUS[value] || { status: value, label: value || 'Desconocido' };

export const KIND_LABEL = { persona: 'Persona', empresa: 'Empresa' };

export const kindLabel = (value) => KIND_LABEL[value] || value || '—';

// Mensajes claros para cada estado que no opera (code promoter_*).
export const statusMessage = (promoter) => {
  const reason = promoter && promoter.statusReason;
  switch (promoter && promoter.status) {
    case 'pending':
      return {
        tone: 'warn',
        title: 'Tu solicitud está en revisión',
        body: 'El equipo de BokerHub revisa a cada promotor antes de darle acceso. Mientras tanto no puedes pedir empresas ni compartir enlaces. Vuelve a entrar más tarde para ver si ya fue aprobada.',
      };
    case 'rejected':
      return {
        tone: 'error',
        title: 'Tu solicitud fue rechazada',
        body: reason
          ? `Motivo: ${reason}`
          : 'BokerHub no aprobó tu solicitud de promotor. Si crees que es un error, escribe a soporte.',
      };
    case 'suspended':
      return {
        tone: 'error',
        title: 'Tu cuenta de promotor está suspendida',
        body: reason
          ? `Motivo: ${reason}`
          : 'Tu cuenta está suspendida y no puede vender por ahora. Escribe a soporte para más información.',
      };
    default:
      return null;
  }
};
